/**
 * 区域管理
 */
<template>
  <div>
    <div style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>验收日志</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div>
        <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
          <el-form-item label="车辆编号:" v-if="show">
            <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="交付人:">
            <el-input size="small" v-model="formInline.delivery_person" placeholder="输入交付人" clearable></el-input>
          </el-form-item>
          <el-form-item label="验收人:">
            <el-input size="small" v-model="formInline.receive_person" placeholder="输入验收人" clearable></el-input>
          </el-form-item>
          <el-form-item label="验车时间:">
            <div class="block">
              <el-date-picker size="small" v-model="formInline.acceptance_date" value-format="yyyy-MM-dd" type="date"
                placeholder="选择验车时间">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="success" icon="el-icon-plus" @click="addAcceptance()"
              v-if="check_auth('/web/acceptance/add2')">添加日志</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="exportSelect()" accept="../../assets/验收.xlsx"
              v-if="check_auth('/web/acceptance/export_excel')">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <div style="margin-top: 20px">
        <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%" ref="multipleTable"
          @selection-change="handleSelectionChange" row-key="id">
          <el-table-column type="selection" reserve-selection align="center" width="55">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="id" label="ID" width="80"></el-table-column>
          <el-table-column align="center" label-aligin="center" prop="vin" min-width="200" label="车辆编号">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="deliveryPerson" min-width="120" label="交付人">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="deliveryPersonPhone" min-width="200"
            label="联系方式（交付）">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="receivePerson" min-width="120" label="验收人">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="receivePersonPhone" min-width="200"
            label="联系方式（验收）">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="acceptanceDateStr" min-width="200" label="验收时间">
          </el-table-column>
          <el-table-column align="center" label-aligin="center" prop="status" min-width="150" label="验收是否成功">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 0">
                <el-button size="mini" type="success" icon="el-icon-check" circle @click="editStatus(scope.row)">
                </el-button>
                <el-button size="mini" type="danger" icon="el-icon-close" circle @click="failStatus(scope.row)">
                </el-button>
              </div>
              <el-tag v-else :color="scope.row.status_type" style="color:white">{{ scope.row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="250"
            v-if="check_auth('/web/acceptance/update')">
            <template slot-scope="scope">
              <el-button round size="mini" @click="editAcceptance(scope.row)"
                v-if="check_auth('/web/acceptance/update')">编辑</el-button>
              <el-button round size="mini" type="danger" @click="delAcceptance(scope.row)"
                v-if="check_auth('/web/acceptance/delete')">删除</el-button>
              <el-button round size="mini" type="info" @click="exportOne(scope.row)"
                v-if="check_auth('/web/acceptance/queryById')">导出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <!-- 添加界面 -->
      <el-dialog :title="addtitle" :visible.sync="addFormVisible" width="45%" @click="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <div style="margin-right: 5%">
          <el-form label-width="70px" :model="addForm" ref="addForm" :rules="rules">
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label-width="25%" label="交付方" prop="交付方">
                    <el-input size="small" v-model="addForm['交付方']" auto-complete="off" placeholder="请输入交付方"></el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="交付联系人" prop="交付联系人">
                    <el-input size="small" v-model="addForm['交付联系人']" auto-complete="off" placeholder="请输入交付联系人">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="联系方式" prop="交付方联系方式">
                    <el-input size="small" v-model="addForm['交付方联系方式']" auto-complete="off" placeholder="请输入交付方联系方式">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="车辆编号" prop="vin">
                    <el-select size="small" style="width: 100%" clearable filterable v-model="addForm.vin"
                      :disabled="disabled" placeholder="请选择车辆编号">
                      <el-option v-for="item in addVinOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label-width="25%" label="接收方" prop="接收方">
                    <el-input size="small" v-model="addForm['接收方']" auto-complete="off" placeholder="请输入接收方"></el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="接收联系人" prop="接收联系人">
                    <el-input size="small" v-model="addForm['接收联系人']" auto-complete="off" placeholder="请输入接收联系人">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="联系方式" prop="接收方联系方式">
                    <el-input size="small" v-model="addForm['接收方联系方式']" auto-complete="off" placeholder="请输入接收方联系方式">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="验收时间" prop="AccepDate">
                    <el-date-picker size="small" style="width: 100%" v-model="addForm.AccepDate" value-format="yyyy-MM-dd"
                      type="date" placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-form-item label-width="12%" label="静态检验" prop="静态检验">
              <el-checkbox-group v-model="form['静态检验']" @change="handleCheckedCitiesChange">
                <el-checkbox name="type" v-for="item in staticInspection" :label="item.status" :key="item.status">{{
                  item.status
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="遥控驾驶" prop="遥控驾驶">
              <el-checkbox-group v-model="form['遥控驾驶']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in drivingTest" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="自动驾驶" prop="自动驾驶">
              <el-checkbox-group v-model="form['自动驾驶']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in automaticDriving" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="作业功能" prop="作业功能">
              <el-checkbox-group v-model="form['作业功能']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in jobFunction" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="配件交接" prop="配件交接">
              <el-checkbox-group v-model="form['配件交接']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in partsHandover" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="其他查验" prop="其他查验">
              <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
                @close="handleClose(tag)">
                {{ tag }}
              </el-tag>
              <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">增加已检功能项</el-button>
            </el-form-item>
            <el-form-item label-width="12%" label="软件功能" prop="软件功能">
              <el-tag :key="tag" v-for="tag in addDynamicTags" closable :disable-transitions="false"
                @close="addHandleClose(tag)">
                {{ tag }}
              </el-tag>
              <el-input class="input-new-tag" v-if="softwareVisible" v-model="softwareValue" ref="softwareTagInput"
                size="small" @keyup.enter.native="addHandleInputConfirm" @blur="addHandleInputConfirm">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="addShowInput">增加已检功能项</el-button>
            </el-form-item>
            <el-button @click="addLine">添加行数</el-button>
            <el-table align="center" :data="templateTable">
              <el-table-column prop="问题描述" width="240px" label="问题描述">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['问题描述']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="整改期限" width="200px" label="整改期限">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['整改期限']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="整改措施" width="240px" label="整改措施">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['整改措施']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="bookbuytime" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" v-if="!scope.row.editing" icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" :loading="loading" class="addtitle" @click="submitAdd('addForm')">添加
          </el-button>
          <el-button size="small" @click="closeDialog('addForm')">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog :title="edittitle" :visible.sync="editFormVisible" width="45%" @click="closeDialog"
        :destroy-on-close="true" :close-on-click-modal="false">
        <div style="margin-right: 5%">
          <el-form label-width="70px" :model="editForm" ref="editForm" :rules="rules">
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label-width="25%" label="交付方" prop="交付方">
                    <el-input size="small" v-model="editForm['交付方']" auto-complete="off" placeholder="请输入交付方">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="交付联系人" prop="交付联系人">
                    <el-input size="small" v-model="editForm['交付联系人']" auto-complete="off" placeholder="请输入交付联系人">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="联系方式" prop="交付方联系方式">
                    <el-input size="small" v-model="editForm['交付方联系方式']" auto-complete="off" placeholder="请输入交付方联系方式">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="车辆编号" prop="vin">
                    <el-select size="small" style="width: 100%" clearable filterable v-model="editForm.vin"
                      :disabled="disabled" placeholder="请选择车辆编号">
                      <el-option v-for="item in editVinOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-form-item label-width="25%" label="接收方" prop="接收方">
                    <el-input size="small" v-model="editForm['接收方']" auto-complete="off" placeholder="请输入接收方">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="接收联系人" prop="接收联系人">
                    <el-input size="small" v-model="editForm['接收联系人']" auto-complete="off" placeholder="请输入接收联系人">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="联系方式" prop="接收方联系方式">
                    <el-input size="small" v-model="editForm['接收方联系方式']" auto-complete="off" placeholder="请输入接收方联系方式">
                    </el-input>
                  </el-form-item>
                  <el-form-item label-width="25%" label="验收时间" prop="AccepDate">
                    <el-date-picker size="small" style="width: 100%" v-model="editForm.AccepDate"
                      value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-form-item label-width="12%" label="静态检验" prop="静态检验">
              <el-checkbox-group v-model="form1['静态检验']" @change="handleCheckedCitiesChange">
                <el-checkbox name="type" v-for="item in staticInspection" :label="item.status" :key="item.status">{{
                  item.status
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="遥控驾驶" prop="遥控驾驶">
              <el-checkbox-group v-model="form1['遥控驾驶']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in drivingTest" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="自动驾驶" prop="自动驾驶">
              <el-checkbox-group v-model="form1['自动驾驶']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in automaticDriving" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="作业功能" prop="作业功能">
              <el-checkbox-group v-model="form1['作业功能']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in jobFunction" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="配件交接" prop="配件交接">
              <el-checkbox-group v-model="form1['配件交接']" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in partsHandover" :label="item.city" :key="item.city">{{ item.city }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label-width="12%" label="其他查验" prop="其他查验">
              <el-tag :key="tag" v-for="tag in editDynamicTags" closable :disable-transitions="false"
                @close="editHandleClose(tag)">
                {{ tag }}
              </el-tag>
              <el-input class="input-new-tag" v-if="editInputVisible" v-model="editInputValue" ref="editSaveTagInput"
                size="small" @keyup.enter.native="editHandleInputConfirm" @blur="editHandleInputConfirm">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="editShowInput">增加已检功能项</el-button>
            </el-form-item>
            <el-form-item label-width="12%" label="软件功能" prop="软件功能">
              <el-tag :key="tag" v-for="tag in editTags" closable :disable-transitions="false"
                @close="handleCloseEdit(tag)">
                {{ tag }}
              </el-tag>
              <el-input class="input-new-tag" v-if="editSoftwareVisible" v-model="editSoftwareValue" ref="editTagInput"
                size="small" @keyup.enter.native="handleInputConfirmEdit" @blur="handleInputConfirmEdit">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInputEdit">增加已检功能项</el-button>
            </el-form-item>
            <el-button @click="editLine">添加行数</el-button>
            <el-table align="center" :data="templateTableEdit">
              <el-table-column prop="问题描述" width="240px" label="问题描述">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['问题描述']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="整改期限" width="200px" label="整改期限">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['整改期限']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="整改措施" width="240px" label="整改措施">
                <template slot-scope="scope">
                  <el-input v-model="scope.row['整改措施']"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="bookbuytime" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" v-if="!scope.row.editing" icon="el-icon-delete"
                    @click="editDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" :loading="loading" @click="submitEdit('editForm')">保存</el-button>
          <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="导出PDF文件" :visible.sync="exportVisible" width="85%" @close="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <div id="pdfDom" style="width: 100%">
        <Pdf style="width: 85%; padding-top: 50px; margin: 0 auto" :editForm="editForm"></Pdf>
      </div>
      <div style="margin-left: 10%; margin-top: 20px">
        <el-button size="small" type="primary" :loading="loading" @click="exportPdf()">导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_acceptanceLog_list,
  get_acceptanceLog_add,
  get_acceptanceLog_one,
  get_acceptanceLog_edit,
  get_acceptanceLog_del,
  get_vin_list,
  get_acceptanceLog_editStatus,
  get_export_acceptanceLog
} from "../../api/projectLog/acceptanceLog";
import {
  auth
} from "../../utils/util";
import Pagination from "../../components/Pagination";
import Pdf from "../pdf.vue";
export default {
  data() {
    return {
      display: false,
      disabled: false,
      staticInspection: [
        { status: "整体漆面完整无变色", tag: "" },
        { status: "外观套件无破损变形", tag: "" },
        { status: "设备完整无漏装或损坏", tag: "" },
        { status: "遥控器等配件完备", tag: "" },
      ],
      drivingTest: [
        { city: "速度", tag: "", tag: "" },
        { city: "转向", tag: "", tag: "" },
        { city: "急停", tag: "", tag: "" },
      ],
      automaticDriving: [
        { city: "巡航", tag: "" },
        { city: "避障", tag: "" },
        { city: "制动", tag: "" },
      ],
      jobFunction: [
        { city: "清扫", tag: "" },
        { city: "喷水", tag: "" },
        { city: "吸储", tag: "" },
      ],
      partsHandover: [
        { city: "使用手册/清单", tag: "" },
        { city: "遥控器", tag: "" },
        { city: "充电线", tag: "" },
        { city: "工具", tag: "" },
      ],
      templateTable: [
        {
          问题描述: "",
          整改期限: "",
          整改措施: "",
        },
      ],
      templateTableEdit: [
        {
          问题描述: "",
          整改期限: "",
          整改措施: "",
        },
      ],
      // 添加
      dynamicTags: [],
      otherTags: [],
      inputVisible: false,
      inputValue: "",
      addDynamicTags: [],
      softwareVisible: false,
      softwareValue: "",
      softwareTags: [],
      // 编辑
      editDynamicTags: [],
      editOtherTags: [],
      editInputVisible: false,
      editInputValue: "",
      editTags: [],
      editSoftwareVisible: false,
      editSoftwareValue: "",
      editSoftwareTags: [],
      form: {
        静态检验: [],
        遥控驾驶: [],
        自动驾驶: [],
        作业功能: [],
        配件交接: [],
      },
      form1: {
        静态检验: [],
        遥控驾驶: [],
        自动驾驶: [],
        作业功能: [],
        配件交接: [],
      },
      exportVisible: false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      loading: false, //是显示加载
      idsval: [],
      ids: [],
      addVinOptions: [],
      editVinOptions: [],
      addtitle: "添加",
      edittitle: "修改",
      addForm: {
        vin: "",
        交付方: "",
        交付联系人: "",
        交付方联系方式: "",
        接收方: "",
        接收联系人: "",
        接收方联系方式: "",
        AccepDate: "",
        carType: "",
      },
      editForm: {
        id: "",
        vin: "",
        交付方: "",
        交付联系人: "",
        交付方联系方式: "",
        接收方: "",
        接收联系人: "",
        接收方联系方式: "",
        AccepDate: "",
        carType: "",
        carTypeName: "",
      },
      // rules表单验证
      rules: {
        vin: [{ required: true, message: "请输入车辆编号", trigger: "change" }],
        交付方: [{ required: true, message: "请输入交付方", trigger: "blur" }],
        交付联系人: [
          { required: true, message: "请输入交付联系人", trigger: "change" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请输入事故名称，如：张三",
            trigger: "change",
          },
        ],
        交付方联系方式: [
          {
            required: true,
            message: "请输入交付方联系方式",
            trigger: "change",
          },
          {
            pattern: /^[1][34578]\d{9}$/,
            message: "请输入正确的手机号，如：136****5645",
            trigger: "change",
          },
        ],
        接收方: [{ required: true, message: "请输入接收方", trigger: "blur" }],
        接收联系人: [
          { required: true, message: "请输入接收联系人", trigger: "change" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请输入接收联系人，如：张三",
            trigger: "change",
          },
        ],
        接收方联系方式: [
          {
            required: true,
            message: "请输入接收方联系方式",
            trigger: "change",
          },
          {
            pattern: /^[1][34578]\d{9}$/,
            message: "请输入正确的手机号，如：136****5645",
            trigger: "change",
          },
        ],
        AccepDate: [
          { required: true, message: "请选择验收时间", trigger: "blur" },
        ],
      },

      formInline: {
        id: "",
        vin: "",
        delivery_person: "",
        receive_person: "",
        acceptance_date: "",
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      listData: [],
      show: true,
    };
  },
  // 注册组件
  components: {
    Pagination,
    Pdf,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
  },
  props: {
    vin: String,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    check_auth(val) {
      return auth(val);
    },
    // 事故列表
    getData() {
      this.show = this.vin == undefined ? true : false;
      if (!this.show) {
        this.formInline.vin = this.vin == undefined ? "" : this.vin;
      }
      get_acceptanceLog_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          this.pageparm.total = res.data.total;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].status_type = {
              "0": "",
              "1": "#E6A23C",
              "2": "#F56C6C",
            }[this.listData[i].status]
            this.listData[i].status = {
              "0": 0,
              "1": "验收成功",
              "2": "验收失败",
            }[this.listData[i].status]

          }
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    // 添加 车辆列表
    getAddCar() {
      get_vin_list().then((res) => {
        if (res["code"] === 0) {
          this.addVinOptions = res.data;
        }
      });
    },
    addLine() {
      var newValue = {
        问题描述: "",
        整改期限: "",
        整改措施: "",
      };
      let count = 0
      //添加新的行数
      if (count < 5) {
        this.templateTable.push(newValue);
        count++
      } else {
        this.$message({
          message: "最多只能添加5条整改措施",
          type: "warning"
        })
      }
    },
    handleDelete(index, row) {
      //删除行数
      this.templateTable.splice(index, 1);
    },
    //显示添加界面
    addAcceptance() {
      this.addFormVisible = true;
      this.templateTable = [
        {
          问题描述: "",
          整改期限: "",
          整改措施: "",
        },
      ];
      (this.form = {
        静态检验: [],
        遥控驾驶: [],
        自动驾驶: [],
        作业功能: [],
        配件交接: [],
      }),
        (this.dynamicTags = []),
        (this.otherTags = []),
        (this.addDynamicTags = []),
        (this.softwareTags = []),
        this.getAddCar();
      for (let i in this.addForm) {
        if (this.addForm[i] === "") {
          this.addForm[i] = "";
        } else {
          this.addForm[i] = [];
        }
      }
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
        this.addForm.vin = this.vin;
      }
    },
    handleCheckedCitiesChange(val) { },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      for (let i = 0; i < this.otherTags.length; i++) {
        if (tag === this.otherTags[i].city) {
          this.otherTags.splice(i, 1);
        }
      }
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      let other = {};
      other.city = this.inputValue;
      other.tag = "√";
      if (inputValue) {
        if (this.dynamicTags.length < 7) {
          this.dynamicTags.push(inputValue);
        }
        if (this.otherTags.length < 7) {
          this.otherTags.push(other);
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    addHandleClose(tag) {
      this.addDynamicTags.splice(this.addDynamicTags.indexOf(tag), 1);
      for (let i = 0; i < this.softwareTags.length; i++) {
        if (tag === this.softwareTags[i].city) {
          this.softwareTags.splice(i, 1);
        }
      }
    },
    addShowInput() {
      this.softwareVisible = true;
      this.$nextTick((_) => {
        this.$refs.softwareTagInput.$refs.input.focus();
      });
    },

    addHandleInputConfirm() {
      let softwareValue = this.softwareValue;
      let software = {};
      software.city = this.softwareValue;
      software.tag = "√";
      if (softwareValue) {
        if (this.addDynamicTags.length < 3) {
          this.addDynamicTags.push(softwareValue);
        }
        if (this.softwareTags.length < 3) {
          this.softwareTags.push(software);
        }
      }
      this.softwareVisible = false;
      this.softwareValue = "";
    },
    // 添加信息
    submitAdd(addData) {
      let sz = {};
      this.$refs[addData].validate((valid) => {
        if (valid) {
          // 循环全的数组
          for (let index = 0; index < this.staticInspection.length; index++) {
            /**
             * 判断一个数据是否在数据内
             */
            const element = this.staticInspection[index];
            if (this.form["静态检验"].indexOf(element.status) > -1) {
              this.staticInspection[index].tag = "√";
            } else {
              this.staticInspection[index].tag = "?";
            }
          }
          for (let i = 0; i < this.drivingTest.length; i++) {
            const element = this.drivingTest[i];
            if (this.form["遥控驾驶"].indexOf(element.city) > -1) {
              this.drivingTest[i].tag = "√";
            } else {
              this.drivingTest[i].tag = "?";
            }
          }
          for (let n = 0; n < this.automaticDriving.length; n++) {
            const element = this.automaticDriving[n];
            if (this.form["自动驾驶"].indexOf(element.city) > -1) {
              this.automaticDriving[n].tag = "√";
            } else {
              this.automaticDriving[n].tag = "?";
            }
          }
          for (let m = 0; m < this.jobFunction.length; m++) {
            const element = this.jobFunction[m];
            if (this.form["作业功能"].indexOf(element.city) > -1) {
              this.jobFunction[m].tag = "√";
            } else {
              this.jobFunction[m].tag = "?";
            }
          }
          for (let x = 0; x < this.partsHandover.length; x++) {
            const element = this.partsHandover[x];
            if (this.form["配件交接"].indexOf(element.city) > -1) {
              this.partsHandover[x].tag = "√";
            } else {
              this.partsHandover[x].tag = "?";
            }
          }
          this.addForm["交接存在问题"] = this.templateTable;
          sz["静态检验"] = this.staticInspection;
          sz["遥控驾驶"] = this.drivingTest;
          sz["自动驾驶"] = this.automaticDriving;
          sz["作业功能"] = this.jobFunction;
          sz["配件交接"] = this.partsHandover;
          sz["其他查验"] = this.otherTags;
          sz["软件功能"] = this.softwareTags;
          this.addForm["项目确认"] = sz;
          var str = JSON.stringify(this.addForm);
          get_acceptanceLog_add(str, this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getData();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑 车辆列表
    getEditCar() {
      get_vin_list().then((res) => {
        if (res["code"] === 0) {
          this.editVinOptions = res.data;
        }
      });
    },
    //显示编辑界面
    editAcceptance(row) {
      this.edittitle = "修改";
      if (this.vin == undefined) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      let sz1 = {};
      let obj = {};
      this.editDynamicTags = [];
      this.editTags = [];
      this.editSoftwareTags = [];
      this.editOtherTags = [];
      (this.form1 = {
        静态检验: [],
        遥控驾驶: [],
        自动驾驶: [],
        作业功能: [],
        配件交接: [],
      }),
        get_acceptanceLog_one(row.id).then((res) => {
          if (res["code"] === 0) {
            this.editForm = res.data.contentObj;
            this.editForm.id = row.id;
            sz1 = res.data.contentObj["项目确认"];
            for (let i = 0; i < sz1["静态检验"].length; i++) {
              if (sz1["静态检验"][i].tag == "√") {
                this.form1["静态检验"].push(sz1["静态检验"][i].status);
              }
            }
            for (let i = 0; i < sz1["遥控驾驶"].length; i++) {
              if (sz1["遥控驾驶"][i].tag == "√") {
                this.form1["遥控驾驶"].push(sz1["遥控驾驶"][i].city);
              }
            }
            for (let i = 0; i < sz1["自动驾驶"].length; i++) {
              if (sz1["自动驾驶"][i].tag == "√") {
                this.form1["自动驾驶"].push(sz1["自动驾驶"][i].city);
              }
            }
            for (let i = 0; i < sz1["作业功能"].length; i++) {
              if (sz1["作业功能"][i].tag == "√") {
                this.form1["作业功能"].push(sz1["作业功能"][i].city);
              }
            }
            for (let i = 0; i < sz1["配件交接"].length; i++) {
              if (sz1["配件交接"][i].tag == "√") {
                this.form1["配件交接"].push(sz1["配件交接"][i].city);
              }
            }
            for (let i = 0; i < sz1["其他查验"].length; i++) {
              if (sz1["其他查验"][i].tag == "√") {
                this.editDynamicTags.push(sz1["其他查验"][i].city);
                obj = {
                  city: sz1["其他查验"][i].city,
                  tag: sz1["其他查验"][i].tag,
                };
                this.editOtherTags.push(obj);
              }
            }
            for (let i = 0; i < sz1["软件功能"].length; i++) {
              if (sz1["软件功能"][i].tag == "√") {
                this.editTags.push(sz1["软件功能"][i].city);
                obj = {
                  city: sz1["软件功能"][i].city,
                  tag: sz1["软件功能"][i].tag,
                };
                this.editSoftwareTags.push(obj);
              }
            }
            this.editFormVisible = true;
            this.templateTableEdit = res.data.contentObj["交接存在问题"];
            this.getEditCar();
          }
        });
    },
    editLine() {
      var newValue = {
        问题描述: "",
        整改期限: "",
        整改措施: "",
      };
      //添加新的行数
      this.templateTableEdit.push(newValue);
    },
    editHandleClose(tag) {
      this.editDynamicTags.splice(this.editDynamicTags.indexOf(tag), 1);
      for (let i = 0; i < this.editOtherTags.length; i++) {
        if (tag === this.editOtherTags[i].city) {
          this.editOtherTags.splice(i, 1);
        }
      }
    },

    editShowInput() {
      this.editInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.editSaveTagInput.$refs.input.focus();
      });
    },
    editHandleInputConfirm() {
      let editInputValue = this.editInputValue;
      let other = {};
      other.city = this.editInputValue;
      other.tag = "√";
      if (editInputValue) {
        if (this.editDynamicTags.length < 7) {
          this.editDynamicTags.push(editInputValue);
        }
        if (this.editOtherTags.length < 7) {
          this.editOtherTags.push(other);
        }
      }
      this.editInputVisible = false;
      this.editInputValue = "";
    },
    handleCloseEdit(tag) {
      this.editTags.splice(this.editTags.indexOf(tag), 1);
      for (let i = 0; i < this.editSoftwareTags.length; i++) {
        if (tag === this.editSoftwareTags[i].city) {
          this.editSoftwareTags.splice(i, 1);
        }
      }
    },
    showInputEdit() {
      this.editSoftwareVisible = true;
      this.$nextTick((_) => {
        this.$refs.editTagInput.$refs.input.focus();
      });
    },

    handleInputConfirmEdit() {
      let editSoftwareValue = this.editSoftwareValue;
      let software = {};
      software.city = this.editSoftwareValue;
      software.tag = "√";
      if (editSoftwareValue) {
        if (this.editTags.length < 3) {
          this.editTags.push(editSoftwareValue);
        }
        if (this.editSoftwareTags.length < 3) {
          this.editSoftwareTags.push(software);
        }
      }
      this.editSoftwareVisible = false;
      this.editSoftwareValue = "";
    },
    editDelete(index, row) {
      //删除行数
      this.templateTableEdit.splice(index, 1);
    },
    // 修改保存
    submitEdit(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let shuzu = {};
          for (let index = 0; index < this.staticInspection.length; index++) {
            /**
             * 判断一个数据是否在数据内
             */
            const element = this.staticInspection[index];
            if (this.form1["静态检验"].indexOf(element.status) > -1) {
              this.staticInspection[index].tag = "√";
            } else {
              this.staticInspection[index].tag = "?";
            }
          }
          for (let i = 0; i < this.drivingTest.length; i++) {
            const element = this.drivingTest[i];
            if (this.form1["遥控驾驶"].indexOf(element.city) > -1) {
              this.drivingTest[i].tag = "√";
            } else {
              this.drivingTest[i].tag = "?";
            }
          }
          for (let n = 0; n < this.automaticDriving.length; n++) {
            const element = this.automaticDriving[n];
            if (this.form1["自动驾驶"].indexOf(element.city) > -1) {
              this.automaticDriving[n].tag = "√";
            } else {
              this.automaticDriving[n].tag = "?";
            }
          }
          for (let m = 0; m < this.jobFunction.length; m++) {
            const element = this.jobFunction[m];
            if (this.form1["作业功能"].indexOf(element.city) > -1) {
              this.jobFunction[m].tag = "√";
            } else {
              this.jobFunction[m].tag = "?";
            }
          }
          for (let x = 0; x < this.partsHandover.length; x++) {
            const element = this.partsHandover[x];
            if (this.form1["配件交接"].indexOf(element.city) > -1) {
              this.partsHandover[x].tag = "√";
            } else {
              this.partsHandover[x].tag = "?";
            }
          }
          this.editForm["交接存在问题"] = this.templateTableEdit;
          shuzu["静态检验"] = this.staticInspection;
          shuzu["遥控驾驶"] = this.drivingTest;
          shuzu["自动驾驶"] = this.automaticDriving;
          shuzu["作业功能"] = this.jobFunction;
          shuzu["配件交接"] = this.partsHandover;
          shuzu["其他查验"] = this.editOtherTags;
          shuzu["软件功能"] = this.editSoftwareTags;
          this.editForm["项目确认"] = shuzu;
          var str = JSON.stringify(this.editForm);
          get_acceptanceLog_edit(str, this.editForm).then((res) => {
            this.editFormVisible = false;
            if (res["code"] === 0) {
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出
    getExport(id) {
      get_export_acceptanceLog(id)
        .then((res) => {
          if (res["code"] == undefined) {
            // 这里根据后端返回使用res或res.data
            var blob = new Blob([res], {
              type: "application/ms-excel",
            });
            var elink = document.createElement("a");
            elink.download = "验收日志" + ".xlsx";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click(); //点击下载
            URL.revokeObjectURL(elink); //释放掉blob对象
            document.body.removeChild(elink); //下载完成移除元素
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: "提示",
            message: err.message,
          });
        });
    },
    exportOne(row) {
      get_acceptanceLog_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data.contentObj;
          this.editForm.carType = res.data.carType;
          this.editForm.carTypeName = res.data.carTypeName;
          this.exportVisible = true;
        }
      });
    },
    exportPdf() {
      this.getPdf("pdfDom", (this.editForm.carTypeName + "-" + this.editForm.vin + "-" + this.editForm.AccepDate));
      this.exportVisible = false;
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    exportSelect() {
      this.ids = []
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].id);
      }
      var str = this.ids.join(",");
      if (this.idsval.length > 0) {
        this.getExport(str);
      } else {
        this.$message.error("下载失败，先选择需要下载的数据");
      }
      this.toggleRowSelect();
    },
    // 删除
    delAcceptance(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          get_acceptanceLog_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getData();
                }
              } else {
                this.getData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editStatus(row) {
      get_acceptanceLog_editStatus(row.id, 1).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
        }
      });
    },
    failStatus(row) {
      get_acceptanceLog_editStatus(row.id, 2).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.exportVisible = false;
      this.editFormVisible = false;
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/projectLog/acceptanceLog_mn.vue